<template>
  <div class="vbox viewport" :class="{ 'with-header': route.path !== '/' && route.path !== '/terms-and-conditions' }">
    <router-view v-slot="{ Component, route: localRoute }">
        <transition name="global-fade" mode="out-in">
            <component :is="Component" :key="localRoute.path === '/' ? 'home' : (localRoute.path === '/terms-and-conditions' ? 'terms' : 'app')" />
        </transition>
    </router-view>
  </div>
</template>
<script setup lang="ts">
    import { computed } from 'vue';
    import { useRoute } from 'vue-router';
    import { useHead } from '@unhead/vue';
    import { BASE_URL, LCP_ORG_URL } from './config';

    const route = useRoute();

    // 1. Get the environment variable (Injected by Azure Pipeline/Vite)
    // Default to 'noindex, nofollow' if the variable is missing (Safety first!)
    const robotsContent = import.meta.env.VITE_ROBOTS_CONTENT || 'noindex, nofollow'

    // Canonical URL: always the absolute production URL for the current path
    const canonicalUrl = computed(() => `${BASE_URL}${route.path}`)

    // Global SEO Default Config
    useHead({
        titleTemplate: '%s - LCP Investment Fee Survey',
        link: [
            { rel: 'canonical', href: canonicalUrl }
        ],
        meta: [
            { name: 'description', content: 'LCP’s fee survey data room lets you easily view investment manager fees by asset classes.' },
            { name: 'author', content: 'Lane Clark & Peacock LLP' },
            { property: 'og:type', content: 'website' },
            { property: 'og:site_name', content: 'LCP Investment Fee Survey' },
            { property: 'og:url', content: canonicalUrl },
            { property: 'og:image', content: `${BASE_URL}/images/ifs-social.png` },
            { name: 'twitter:card', content: 'summary_large_image' },
            {
                name: 'robots',
                content: robotsContent
            }
        ],
        script: [
            {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "SoftwareApplication",
                    "name": "LCP Investment Fee Survey",
                    "operatingSystem": "All",
                    "applicationCategory": "BusinessApplication",
                    "offers": {
                      "@type": "Offer",
                      "price": "0",
                      "priceCurrency": "GBP"
                    },
                    "url": BASE_URL,
                    "author": {
                      "@type": "Organization",
                      "name": "Lane, Clark & Peacock LLP",
                      "url": LCP_ORG_URL,
                      "logo": `${LCP_ORG_URL}/media/ipqjtxx3/branding_logo.svg`,
                      "@id": `${LCP_ORG_URL}/#organization`
                    },
                    "publisher": {
                      "@id": `${LCP_ORG_URL}/#organization`
                    }
                })
            }
        ]
    });
</script>

<style lang="scss">
    // Global styles moved to src/sass/main.scss
</style>
